import './leaderboard-skeleton.scss';

export function LeaderboardSkeleton() {
  return (
    <>
      {Array.from({ length: 8 }).map((_, i) => (
        <div key={i} className="leaderboard-skeleton">
          <div className="leaderboard-skeleton__rank" />
          <div className="leaderboard-skeleton__avatar" />
          <div className="leaderboard-skeleton__text">
            <div className="leaderboard-skeleton__line leaderboard-skeleton__line--wide" />
            <div className="leaderboard-skeleton__line leaderboard-skeleton__line--narrow" />
          </div>
          <div className="leaderboard-skeleton__profit" />
        </div>
      ))}
    </>
  );
}
